import React, { useEffect } from "react";
import {
  FaFlask,
  FaMapMarkerAlt,
  FaCalendarCheck,
  FaFileUpload,
  FaBell,
  FaCreditCard,
  FaHeadset,
  FaTruck,
  FaUserShield,
  FaCheckCircle,
  FaArrowRight
} from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Services() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const services = [
    {
      icon: <FaTruck size={22} />,
      title: "Doorstep Sample Collection",
      desc: "NABL certified phlebotomists visit your home or office with temperature-regulated cold boxes for hygienic blood sample collection.",
      tag: "100% Hygienic"
    },
    {
      icon: <FaFlask size={22} />,
      title: "Full Body Diagnostic Profiles",
      desc: "Preventive health checkups covering CBC, Lipid, Liver, Kidney, Thyroid, Vitamins, and Cardiac markers at up to 70% discounted prices.",
      tag: "Best Value"
    },
    {
      icon: <FaMapMarkerAlt size={22} />,
      title: "Certified Lab Network Discovery",
      desc: "Find and compare 500+ ISO & NABL accredited diagnostic centers and pathology labs near your current location.",
      tag: "Live GPS"
    },
    {
      icon: <FaFileUpload size={22} />,
      title: "Instant Digital Reports",
      desc: "Get verified digital test reports delivered directly to your WhatsApp and patient dashboard within 6 to 24 hours.",
      tag: "Fast Turnaround"
    },
    {
      icon: <FaCalendarCheck size={22} />,
      title: "Prescription Upload & Booking",
      desc: "Simply upload your doctor's handwritten prescription and our medical team will automatically curate your test package.",
      tag: "1-Click Assist"
    },
    {
      icon: <FaHeadset size={22} />,
      title: "24x7 Dedicated Medical Support",
      desc: "Free telephonic consultation with healthcare advisors to assist in selecting tests and interpreting diagnostic biomarkers.",
      tag: "Free Expert Advice"
    },
  ];

  return (
    <div className="w-full min-h-screen bg-slate-50 text-slate-800">
      
      {/* HERO SECTION */}
      <section className="relative bg-gradient-to-br from-red-600 via-red-700 to-rose-800 text-white py-16 md:py-20 px-4 sm:px-6 lg:px-12 overflow-hidden">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-white/10 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-amber-400/10 rounded-full blur-3xl pointer-events-none" />

        <div className="max-w-4xl mx-auto text-center relative z-10">
          <span className="inline-block text-xs font-bold text-amber-200 uppercase tracking-widest bg-white/15 border border-white/20 px-3.5 py-1 rounded-full mb-4">
            Comprehensive Pathology & Diagnostics
          </span>
          <h1 className="text-3xl sm:text-5xl font-black tracking-tight text-white leading-tight">
            Our Healthcare Services
          </h1>
          <p className="mt-4 text-sm sm:text-base text-red-100 max-w-2xl mx-auto leading-relaxed">
            From routine blood testing to comprehensive full-body preventive checkups, MedrphaLab delivers hospital-grade pathology to your home.
          </p>
        </div>
      </section>

      {/* SERVICES GRID */}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-14 md:py-20">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-6 border border-slate-200/80 shadow-xs hover:shadow-xl hover:border-red-300 hover:-translate-y-1 transition-all duration-300 flex flex-col justify-between group"
            >
              <div>
                <div className="flex items-center justify-between mb-4">
                  <div className="w-12 h-12 rounded-2xl bg-red-50 text-red-600 flex items-center justify-center group-hover:bg-red-600 group-hover:text-white transition-all shadow-xs">
                    {service.icon}
                  </div>
                  <span className="text-[10px] font-bold text-red-700 bg-red-50 px-2.5 py-1 rounded-full border border-red-100">
                    {service.tag}
                  </span>
                </div>
                <h3 className="text-base sm:text-lg font-bold text-slate-900 mb-2">
                  {service.title}
                </h3>
                <p className="text-xs sm:text-sm text-slate-600 leading-relaxed">
                  {service.desc}
                </p>
              </div>

              <div className="mt-6 pt-4 border-t border-slate-100 flex items-center text-xs font-bold text-red-600 group-hover:text-red-700 gap-1.5">
                <span>Explore Service</span>
                <FaArrowRight size={10} className="group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          ))}
        </div>

        {/* BOTTOM CTA CARD */}
        <div className="mt-12 bg-gradient-to-r from-red-600 to-rose-600 rounded-3xl p-8 text-white shadow-xl flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-xl md:text-2xl font-black">
              Ready to Book Your Health Checkup?
            </h3>
            <p className="text-xs md:text-sm text-red-100 mt-1 max-w-xl">
              Enjoy 100% free home sample collection with verified pathology reports delivered in 6 hours.
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <Link
              to="/all-packages"
              className="px-6 py-3 bg-white text-red-600 hover:bg-slate-100 rounded-xl text-xs sm:text-sm font-bold shadow-md transition-all cursor-pointer"
            >
              View All Packages
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
}
